/**
 * @file PickedTileValue.tsx
 * @description Значение плитки «Собрано» в шапке задания: число и тонкая
 * полоса прогресса под ним (phase19.23).
 *
 * Полоса живёт в плитке, а не отдельной строкой над списком позиций: тот же
 * прогресс дважды текстом на одном экране — шум (замечание пользователя
 * 2026-09-16). На телефоне прогресс остаётся в sticky-панели снизу.
 *
 * Полоса и зазор укладываются в `min-h-16` плитки (`DocumentMetaGrid`): иначе
 * «Собрано» выше соседних плиток, и ряд в шапке выглядит кривым.
 */

import {
  formatPickedPositions,
  formatShortagePositions,
  pickedPercent,
} from "../../../lib/picking-format";

interface Props {
  picked: number;
  total: number;
  /** Строк, закрытых недостачей; 0 — второй строки нет (§3.2). */
  shortageCount?: number;
}

export function PickedTileValue({ picked, total, shortageCount = 0 }: Props) {
  const percent = pickedPercent(picked, total);
  return (
    <span className="flex flex-col gap-0.5">
      {/* Метрика одна на весь экран — позиции (решение пользователя 2026-09-20). */}
      <span>{formatPickedPositions(picked, total)}</span>
      <span
        role="progressbar"
        aria-valuenow={percent}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label="Прогресс сборки"
        className="block h-1 overflow-hidden rounded-full bg-on-surface/10"
      >
        <span
          className="block h-full rounded-full bg-primary transition-[width] duration-300"
          style={{ width: `${percent}%` }}
        />
      </span>
      {shortageCount > 0 ? (
        <span className="text-xs text-destructive">
          {formatShortagePositions(shortageCount)}
        </span>
      ) : null}
    </span>
  );
}
